<template>
  <b-tabs align="center">
    <template #tabs-end>
      <li v-if="activeTabTitle === 'Gerenciar Fluxos'" class="nav-item dk-tabs-action">
        <b-button
          variant="outline-danger"
          size="sm"
          class="dk-criar-fluxo-btn"
          @click="$root.$emit('open-criar-fluxo')"
        >
          <feather-icon icon="PlusIcon" size="13" class="mr-25" />
          Criar Fluxo
        </b-button>
      </li>
    </template>

    <b-tab
      v-for="(tab, index) in tabs"
      :key="index"
      class="`${index}_${tab.title}`"
      :active="tab.active"
      align="start"
      @click="changeEvent(tab)"
    >
      <template #title>
        <feather-icon :icon="tab.icon" />
        <span>{{ tab.title }}</span>
      </template>

      <component :is="tab.component" />
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab, BButton } from 'bootstrap-vue'
import Chat from '@/views/App/Chat/Chats.vue'
import DeashbordChat from '@/views/App/Dashboard/DashbordChat.vue'
import TabIntegrationRdStation from '@/views/App/Integracoes/TabIntegrationRdStation.vue'
import TabIntegrationPipeDrive from '@/views/App/Integracoes/TabIntegrationPipeDrive.vue'
import TabIntegrationActiveCampaign from '@/views/App/Integracoes/TabIntegrationActiveCampaign.vue'

import DesignChat from '@/views/App/Chat/design.vue'

export default {
  components: {
    BTabs,
    BTab,
    BButton,
    Chat,
    DeashbordChat,
    TabIntegrationRdStation,
    TabIntegrationPipeDrive,
    TabIntegrationActiveCampaign,
    DesignChat,
  },
  data() {
    return {
    }
  },
  computed: {
    currentTab: {
      get() {
        return this.$store.state.AppChatbooster.tabAtual
      },
      set(value) {
        this.$store.commit('AppChatbooster/SET_CURRENT_TAB', value)
      },
    },
    tabs: {
      get() {
        return this.$store.state.AppChatbooster.tabs
      },
      set(value) {
        this.$store.commit('AppChatbooster/SET_TABS', value)
      },
    },
    activeTabTitle() {
      const active = this.tabs.find(t => t.active)
      return active ? active.title : ''
    },
  },
  mounted() {
    const tabAtivas = this.tabs.find(tab => tab.active)
    this.$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', tabAtivas.component)
  },
  methods: {
    changeEvent(tab) {
      this.$store.commit('appHelperTour/SET_TYPE_HELPER_TOUR', tab.component)
      if (tab.title !== this.$store.getters['AppChatbooster/GET_CURRENT_TAB_ACTIVE']) {
        if (Object.keys(this.$route.query).length > 0) {
          this.$router.replace({ params: {}, query: {} })
        }
        this.$store.commit('AppChatbooster/RESET_TABS', tab)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$dk-orange: #E86A10;

.dk-tabs-action {
  display: flex;
  align-items: center;
  margin-left: auto;
  padding: 0 4px;
}
.dk-criar-fluxo-btn {
  font-size: 0.82rem !important;
  font-weight: 700 !important;
  padding: 8px 18px !important;
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
  white-space: nowrap !important;
  border-radius: 10px !important;
  background: $dk-orange !important;
  border-color: $dk-orange !important;
  color: #fff !important;
  box-shadow: 0 3px 10px rgba($dk-orange, 0.3) !important;
  transition: all 0.15s !important;

  &:hover {
    background: darken($dk-orange, 6%) !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 5px 16px rgba($dk-orange, 0.4) !important;
  }
}

// ── Tab navigation styling ──
::v-deep .nav-tabs {
  background: var(--dk-bg-card, #fff) !important;
  border: 1px solid var(--dk-border, #edf1f4) !important;
  border-radius: 12px !important;
  padding: 6px !important;
  margin-bottom: 16px !important;
  box-shadow: var(--dk-shadow-sm) !important;
  gap: 4px !important;

  .nav-item .nav-link {
    border: none !important;
    border-radius: 8px !important;
    padding: 8px 18px !important;
    font-size: 0.84rem !important;
    font-weight: 600 !important;
    color: var(--dk-text-secondary, #6b7a8d) !important;
    transition: all 0.15s !important;
    display: flex !important;
    align-items: center !important;
    gap: 6px !important;

    &:hover {
      background: var(--dk-bg-card-hover, #f8fafc) !important;
      color: var(--dk-text-primary, #0D3349) !important;
    }

    &.active {
      background: rgba($dk-orange, 0.1) !important;
      color: $dk-orange !important;
      font-weight: 700 !important;
    }
  }
}
</style>
